/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiTokenDataFromJSON(json) {
    return ApiTokenDataFromJSONTyped(json, false);
}
export function ApiTokenDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accessToken': !exists(json, 'accessToken') ? undefined : json['accessToken'],
        'expiresIn': !exists(json, 'expiresIn') ? undefined : json['expiresIn'],
        'tokenType': !exists(json, 'tokenType') ? undefined : json['tokenType'],
    };
}
export function ApiTokenDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accessToken': value.accessToken,
        'expiresIn': value.expiresIn,
        'tokenType': value.tokenType,
    };
}
